<form [formGroup]="dataSourceForm">
  <div class="group">
    <p class="label">Name *</p>
    <input autocomplete="off" matInput class="username" formControlName="name" placeholder="Enter name" />
    <div *ngIf="deviceNameCtrl.invalid && deviceNameCtrl.touched">
      <mat-error *ngIf="deviceNameCtrl.hasError('required')">Name is required</mat-error>
    </div>
    <div *ngIf="deviceNameCtrl.invalid">
      <mat-error *ngIf="dataSourceForm.hasError('maxlength', 'name')">Name is too long</mat-error>
    </div>
  </div>

  <div class="group">
    <p class="label">Host *</p>
    <input autocomplete="off" matInput class="hostname" formControlName="hostname" placeholder="Enter host" />
    <div *ngIf="hostNameCtrl.invalid && hostNameCtrl.touched">
      <mat-error *ngIf="dataSourceForm.hasError('required', 'hostname')">Host name is required</mat-error>
    </div>
  </div>

  <div class="group">
    <p class="label">Username *</p>
    <input autocomplete="off" matInput class="username" formControlName="username" placeholder="Enter username" />

    <div *ngIf="userNameCtrl.invalid && userNameCtrl.touched">
      <mat-error *ngIf="dataSourceForm.hasError('required', 'username')">Username is required</mat-error>
    </div>
    <div *ngIf="userNameCtrl.invalid">
      <mat-error *ngIf="dataSourceForm.hasError('maxlength', 'username')">Username is too long</mat-error>
    </div>
  </div>

  <div class="group">
    <p class="label">Password <span class="required-field" *ngIf="passwordMandatory">*</span></p>
    <!-- adding autocomplete directive disables autocomplete and prevents password from being overridden by web browser -->
    <input matInput formControlName="password" class="password" placeholder= "{{placeHolderText}}"
      autocomplete="new-password"
       [type]="hide ? 'password' : 'text'" />
    <div class="visibility-toggler">
      <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
    </div>
    <div *ngIf="passwordCtrl.invalid && passwordCtrl.touched">
      <mat-error *ngIf="dataSourceForm.hasError('required', 'password')">Password is required</mat-error>
    </div>
    <div *ngIf="passwordCtrl.invalid">
      <mat-error *ngIf="dataSourceForm.hasError('maxlength', 'password')">Password is too long</mat-error>
    </div>
  </div>
</form>
